import FormErrors from "@/components/FormErrors/FormErrors";
import HmAutocompleteObject from "@/components/Autocomplete/AutocompleteObject.vue";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import { JSConn } from "@/utilities/js-conn";
import { format } from "date-fns";

export default {
  name: "createWorkOrderForm",
  components: {
    FormErrors,
    HmAutocompleteObject,
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading data to create work order...",
      hasFormErrors: false,
      formErrors: [],
      createWorkOrder: {
        submitted_date: null,
        client_field: {},
        client_field_id: null,
        template: {},
        template_id: null,
      },
    };
  },
  created() {
    const jsConn = new JSConn();
    const jsConnTemplateWorkOrders = new JSConn();
    const dataPromises = [
      this.$store.dispatch("needClientFields", jsConn),
      this.$store.dispatch("needTemplateWorkOrders", jsConnTemplateWorkOrders),
    ];

    Promise.all(dataPromises).then(() => {
      this.dataLoaded = true;
      return Promise.resolve();
    });
  },
  methods: {
    submitTemplateForm(evt) {
      evt.preventDefault();

      const jsConn = new JSConn();
      const td = format(new Date(), "yyyy-MM-dd");

      jsConn.formParams = {
        client_field_id: this.createWorkOrder.client_field_id,
        template_id: this.createWorkOrder.template_id,
        submitted_date: td,
      };

      this.$store.dispatch("createWorkOrderFromTemplate", jsConn).then(() => {
        this.$router.push({
          name: "workOrders",
        });
        return Promise.resolve();
      });
    },
    updateTemplate(evt) {
      this.createWorkOrder.template = evt;
      this.createWorkOrder.template_id = evt.value;
    },
    updateClientField(evt) {
      this.createWorkOrder.client_field = evt;
      this.createWorkOrder.client_field_id = evt.value;
    },
  },
  computed: {
    clientFieldsForAutocomplete: function() {
      return this.$store.getters.clientFieldsForAutocomplete;
    },
    templateWorkOrdersForAutocomplete: function() {
      return this.$store.getters.templateWorkOrdersForAutocomplete;
    },
  },
};
